import {html} from 'lit';

export const facet6Template = (isDefault: boolean) => html`
    <div class="image-shapes-6--crop-mobile">
        <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
             x="0px" y="0px"
             viewBox="0 0 360 270" xml:space="preserve">
                <path class="fill-yellow400" d="M283.2,183.6l72.7,42.1l-72.7,42l-72.7-42.1L283.2,183.6 M283.2,181.3l-76.7,44.3l76.7,44.4l76.7-44.3
\tL283.2,181.3L283.2,181.3z"/>
                <path class="fill-violet3-opacity-75"
                      d="M0,229.2l0.1-63.8l50.4-29l50.3,28.9v57.9l-55.4,31.9C25.1,266.9-0.1,252.3,0,229.2z"/>
        </svg>
    </div>

    <div class="image-shapes-6">
        <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
             x="0px" y="0px"
             viewBox="0 0 397 327" xml:space="preserve">
            <path class="fill-yellow400" d="M114.7,272l-57.1-33L0.4,272l57.1,33L114.7,272z"/>
            <path class="fill-violet3-opacity-75"
                  d="M375.9,144.2l-42.4,24.4L295,146.3l0-44.5l38.5-22.2l42.4,24.5C391.3,113.1,391.3,135.3,375.9,144.2z"/>
            <path class="fill-yellow600" d="M57.5,173l-42.9,24.7c-8.8,5.1-14.3,14.5-14.3,24.7V272l57.1-33L57.5,173z"/>
            <g>
                <path class="fill-lightblue400" d="M297.2,240l71.8,41.4l-71.8,41.4l-71.8-41.4L297.2,240 M297.2,237.7l-75.8,43.7l75.8,43.7l75.8-43.7
                L297.2,237.7L297.2,237.7z"/>
            </g>
        </svg>
    </div>

    <div class="image-shapes-6--xl">
        ${isDefault ? html`
            <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 437 396" xml:space="preserve">
                <g>
                    <path class="fill-yellow400" d="M156.7,336.7l-71.6-41.3l-70.5,40.8L85.1,378L156.7,336.7z"/>
                    <path class="fill-violet3-opacity-75"
                          d="M422.4,40.8l-0.1,59.8l-47.2,27.2l-47.1-27.1l0-54.5L380,16.4C398.9,5.5,422.5,19.1,422.4,40.8z"/>
                    <path class="fill-yellow600"
                          d="M85.1,214l-52.9,30.5c-10.9,6.3-17.6,17.9-17.6,30.5v61.1l70.5-40.7V214z"/>
                </g>
            </svg>
        ` : html`
            <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 439 397" xml:space="preserve">
                <path class="fill-yellow600"
                      d="M366.6,186.9l53.9-31.1c11.1-6.4,18-18.3,18-31.1V62.3l-71.9,41.5V186.9z"/>
                <path class="fill-yellow400" d="M438.5,62.3l-71.9-41.6l-71.9,41.5l71.9,41.6L438.5,62.3z"/>
                <path class="fill-violet3-opacity-75"
                      d="M29.3,358.5l0.1-59.8l47.2-27.2l47.1,27.1l0,54.3l-51.9,29.9C52.8,393.8,29.2,380.2,29.3,358.5z"/>
            </svg>
        `}
    </div>
`;